import RelatorioEssencialPJQuery from "../queries/RelatorioEssencialPJQuery";
import AvaliePlusCPFQuery from "../queries/RelatorioEssencialPFQuery";
import CompletaPlusCNPJForm from "../forms/CompletaPlusCNPJForm";
import ScrBacenScoreQuery from "../queries/ScrBacenScoreQuery";
import DefineLimitePositivoQuery from "../queries/DefineLimitePositivoQuery";
import AvalieCompletoPFQuery from "../queries/AvalieCompletoPFQuery";
import AvalieCompletoPJQuery from "../queries/AvalieCompletoPJQuery";
import RelatorioAvancadoPJQuery from "../queries/RelatorioAvancadoPJQuery";

export const componentsMap = {
  AvaliePlusCPFQuery,
  RelatorioEssencialPJQuery,
  CompletaPlusCNPJForm,
  ScrBacenScoreQuery,
  DefineLimitePositivoQuery,
  AvalieCompletoPFQuery,
  RelatorioAvancadoPJQuery,
  AvalieCompletoPJQuery,
};
